import { Box, Container } from '@mui/material';

import MobilityVehiclesContent from '../components/MobilityVehiclesContent';

/** The same content mounts without this chrome as a tab on the Mobile Service and Parts
 *  Delivery shells. */
const MobilityVehiclesPage = () => (
  <Box sx={{ py: 3 }}>
    <Container maxWidth='lg'>
      <MobilityVehiclesContent showTitle />
    </Container>
  </Box>
);

export default MobilityVehiclesPage;
